import React, { useMemo, useRef } from 'react';
import './_list.twig.editor.scss'
import './_list.twig.editor.dark-mode.scss'
import { Badge, Button, Col, DropdownButton, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Tooltip from '../../../../../../components/Tooltip';
import { routesAppearance } from '../../../../helpers';

const ThemeItem = ({
  item,
  isLoading,
  onActivateTheme,
  onOpenModal,
}) => {
  const history = useHistory();
  const themesPreviewRoute = useMemo(() => routesAppearance.find((route) => route.code === 'themes-preview'), [])
  const nodeRef = useRef(null);

  const isDropUp = useMemo(() => {
    const card = nodeRef?.current ? nodeRef.current.getBoundingClientRect() : 0;
    const wrapperPage = document.getElementById('page-wrapper');
    if (card) {
      if ((card.bottom + wrapperPage.scrollTop) - wrapperPage.scrollHeight > 0) {
        return true;
      }
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodeRef.current])

  const onEditCode = (e, themeId) => {
    e.preventDefault();
    history.push({
      pathname: themesPreviewRoute.link,
      search: `theme_id=${themeId}`,
    })
  }

  return (
    <Col lg={4} md={6}>
      <div className="list-twig__card">
        <div className="list-twig__card-preview" style={{ backgroundImage: `url(${item.thumbnail})` }}>
          {item.active ? <Badge>Active</Badge>
            : (item?.access?.activate
              ? (
                <div className="list-twig__card-activate">
                  <Button bsStyle="primary" onClick={() => onActivateTheme(item.id)} disabled={isLoading}>Activate</Button>
                </div>
              ) : null)}
          {item.last_modified ? (
            <div className="list-twig__card-updated">
              <div>
                <Tooltip
                  placement="top"
                  tooltipClass="tooltip__top"
                  text={(
                    <p>
                      Last modified
                      <br />
                      {' '}
                      {item.last_modified}
                    </p>
                  )}
                >
                  <i className="far fa-clock" />
                </Tooltip>
              </div>
            </div>
          ) : null }
        </div>
        <div className="list-twig__card-panel" ref={nodeRef}>
          <div className="list-twig__card-title">
            <span>{item.name}</span>
          </div>
          <div className="list-twig__card-actions">
            <DropdownButton
              bsSize="xsmall"
              title="Actions"
              dropup={isDropUp}
              pullRight
              id={`action-theme-${item.id}`}
            >
              <MenuItem eventKey="1" onClick={(e) => onEditCode(e, item.id)}>Edit theme</MenuItem>
              {item?.access?.rename && <MenuItem eventKey="2" onClick={() => onOpenModal('rename', item)}>Rename</MenuItem>}
              {item?.access?.copy && <MenuItem eventKey="3" onClick={() => onOpenModal('copy', item)}>Create a copy</MenuItem>}
              {item?.access?.delete && <MenuItem eventKey="4" onClick={() => onOpenModal('delete', item)}>Delete</MenuItem>}
            </DropdownButton>
          </div>
        </div>
      </div>
    </Col>
  );
}

ThemeItem.propTypes = {
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  onActivateTheme: PropTypes.func,
  onOpenModal: PropTypes.func,
};

export default ThemeItem;
